import { useContext } from 'react'
import { StoreContext } from '@/hooks/contexts.js'

export default function useStore() {
  return useContext(StoreContext)
}
